var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    _vm._g(
      _vm._b(
        {
          staticClass: "hkl-modal",
          model: {
            value: _vm.proxyVisible,
            callback: function ($$v) {
              _vm.proxyVisible = $$v
            },
            expression: "proxyVisible",
          },
        },
        "a-modal",
        _vm.bindAttrs,
        false
      ),
      _vm.onListeners
    ),
    [
      _c("template", { slot: "title" }, [_vm._t("title")], 2),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hkl-modal__footer" },
        [
          _vm._t("footer", function () {
            return [
              _vm.hasCancelBtn
                ? _c("HKLButton", {
                    attrs: { color: "darkblue", action: _vm.cancelBtnAction },
                    on: { click: _vm.onClose },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasOkBtn
                ? _c("HKLButton", {
                    attrs: {
                      disabled: _vm.okBtnDisabled,
                      color: "orange",
                      action: _vm.okBtnAction,
                    },
                    on: { click: _vm.onClick },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }